import DefaultListPanel from "./DefaultListPanel.vue";

export default DefaultListPanel;